import { SET_GRID_CONFIG } from '../actionTypes';
import { actions } from '../reducer';

export default (values) => actions[SET_GRID_CONFIG](values);
